import type { MediaItem, MediaItemDetails, MediaItemDTO } from "../types/mediaLibraryTypes";

export function mediaTransformer(dto?: MediaItemDTO[]): MediaItem[] {
  if (!Array.isArray(dto)) {
    return [];
  }

  return dto.map(
    (item): MediaItem => ({
      id: String(item.id),
      groupId: String(item.groupId),
      downloadUrl: item.downloadUrl,
      previewUrl: item.previewUrl,
      mediaType: item.mediaType,
      isFavourite: Boolean(item.isFavourite),
      title: item.title || "",
      language: item.language || "",
      documentType: item.documentType || "",
    }),
  );
}

export function mediaDetailsTransformer(dto?: MediaItemDTO[]): MediaItemDetails[] {
  if (!Array.isArray(dto)) {
    return [];
  }

  return dto.map((item) => ({
    id: String(item.id),
    groupId: String(item.groupId),
    downloadUrl: item.downloadUrl,
    previewUrl: item.previewUrl,
    mediaType: item.mediaType,
    isFavourite: Boolean(item.isFavourite),
    title: item.title || "",
    language: item.language || "",
    description: item.description || "",
    size: item.size ?? 0,
    width: item.width ?? 0,
    height: item.height ?? 0,
    videoPreviewUrl: item.videoPreviewUrl || "",
    documentPages: item.documentPages ?? [],
    pageCount: item.pageCount ?? 0,
    documentType: item.documentType || "",
  }));
}
